import React, { useState } from 'react';
import { Typography, Popover } from 'antd';
import NameFormatter from './NameFormatter';

const fallbackImg = '/icons/noimage.svg';

const OwerflowNameFormatter = ({ title, className, img, key }) => {
  const [imgSrc, setImgSrc] = useState(img || null);

  return (
    <Typography
      className={`${className} text-sm w-full h-fit flex items-center text-ellipsis text-left font-normal`}
    >
      {imgSrc && (
        <Popover
          getPopupContainer={() => document.body}
          destroyOnHidden
          placement='right'
          content={
            <div>
              <img
                key={key}
                src={imgSrc}
                alt='Product'
                width={100}
                height={100}
                className='object-cover rounded-md !z-50'
                onError={() => setImgSrc(fallbackImg)}
              />
            </div>
          }
          trigger='hover'
        >
          <img
            key={key}
            src={imgSrc}
            alt='Product'
            width={35}
            height={35}
            onError={() => setImgSrc(fallbackImg)}
            style={{ pointerEvents: 'auto' }}
            className='object-cover mr-1 bg-white border border-gray-200 rounded-md cursor-pointer'
          />
        </Popover>
      )}
      <div className='pl-2 text-ellipsis whitespace-nowrap overflow-hidden w-full !text-xs'>
        <NameFormatter name={title || '-'} />
      </div>
    </Typography>
  );
};

export default OwerflowNameFormatter;
